var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrap"},[_c('b-alert',{attrs:{"show":"","variant":"success"}},[_vm._v("\r\n    Идет загрузка данных. Пожалуйста подождите "),_c('i',{staticClass:"fa fa-spinner fa-spin",attrs:{"aria-hidden":"true"}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }